module.exports = __webpack_public_path__ + "img/1.a2ca9ad8.png";